import FinancialRecord from '#calculator/financialRecords/FinancialRecord'
import { isAdjustableExpense } from '#dictionary'

const scaleAnnualValue = (
  record: FinancialRecord,
  multiplier: number
): FinancialRecord => {
  if (multiplier === 1) return record

  // TODO: simplify once FinancialRecord is replaced with a plain JS object
  return new FinancialRecord(
    {
      id: record.id,
      name: record.name,
      ownerId: record.owner.id,
      finCategoryKey: record.finCategory.key,
      startAt: record.startAt,
      endAt: record.endAt,
      annualValue: record.annualValue * multiplier,
      valuePart: record.valuePart,
      recurringValue: record.recurringValue,
      customRate:
        record.growthRate !== record.finCategory.rate
          ? record.growthRate
          : null,
      parentId: record.parentId,
      realEstateRegion: null,
      realEstateTaxRate: null,
      questId: record.questId,
      t_fromAssetId: record.t_fromAssetId,
      t_toAssetId: record.t_toAssetId,
    },
    record.finCategory,
    record.owner
  )
}

const isActiveIncome = (record: FinancialRecord): boolean =>
  record.finCategory.isActiveIncome

export type RecordAdjustments = {
  incomeMultiplier?: number
  expenseMultiplier?: number
}

export const adjustRecords = (
  records: readonly FinancialRecord[],
  { incomeMultiplier, expenseMultiplier }: RecordAdjustments
): FinancialRecord[] =>
  records.map(record => {
    if (incomeMultiplier !== undefined && isActiveIncome(record)) {
      return scaleAnnualValue(record, incomeMultiplier)
    }
    if (
      expenseMultiplier !== undefined &&
      isAdjustableExpense(record.finCategory)
    ) {
      return scaleAnnualValue(record, expenseMultiplier)
    }
    return record
  })
